import React from 'react'
import { useParams } from 'react-router-dom'

import { getLogoFromRelatory } from '@util/AuthUtil'

const MainTitleLogo = () => {
  const { insurance } = useParams()
  return <img src={getLogoFromRelatory(insurance)} alt="Logo" style={{ width: 110 }} />
}

export default MainTitleLogo
